module.exports = __webpack_public_path__ + "static/media/dawn-nature.b5a47d81.jpg";